// For Vite, we need to use import.meta.env instead of process.env
// Environment variables must be prefixed with VITE_ instead of NEXT_PUBLIC_


const env = (key: string) => {
  if (!import.meta.env[key]) {
    throw new Error(`Environment variable ${key} is not set`);
  }
  return import.meta.env[key];
}

export const SUPABASE_URL = env("VITE_SUPABASE_URL");
export const SUPABASE_ANON_KEY = env("VITE_SUPABASE_ANON_KEY");
export const STRIPE_KEY = env("VITE_STRIPE_KEY");
export const GOOGLE_CLIENT_ID = env("VITE_GOOGLE_CLIENT_ID");

// Check for backend_url query parameter first
const getCloudflareUrlFromQuery = () => {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    return params.get("backend_url");
  }
  return null;
};

export const CLOUDFLARE_URL = getCloudflareUrlFromQuery() ?? env("VITE_CLOUDFLARE_URL");

export const DISCORD_OAUTH_URL = CLOUDFLARE_URL + "/discord/link";